import { ReembolsoService } from './services/reembolso.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatListModule } from '@angular/material/list';
import { MatInputModule } from '@angular/material/input';
import { HttpModule } from '@angular/http';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatRadioModule } from '@angular/material/radio';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { TextMaskModule } from 'angular2-text-mask';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { HomeComponent } from './components/home/home.component';
import { RegisterComponent } from './components/register/register.component';
import { AccountComponent } from './components/account/account.component';
import { ExtractComponent } from './components/extract/extract.component';
import { CreditCardComponent } from './components/credit-card/credit-card.component';
import { CreditCardSingleComponent } from './components/credit-card-single/credit-card-single.component';
import { DependentCardComponent } from './components/dependent-card/dependent-card.component';
import { DependentSingleComponent } from './components/dependent-single/dependent-single.component';
import { DailyLimitComponent } from './components/daily-limit/daily-limit.component';
import { RestrictionComponent } from './components/restriction/restriction.component';
import { RestrictionSingleComponent } from './components/restriction-single/restriction-single.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { RegisterDependentComponent } from './components/register-dependent/register-dependent.component';
import { HeaderComponent } from './components/header/header.component';
import { GeneralComponent } from './components/general/general.component';
import { RechargeComponent } from './components/recharge/recharge.component';
import { InputComponent } from './components/input/input.component';
import { TextareaComponent } from './components/textarea/textarea.component';
import { InputSelectComponent } from './components/input-select/input-select.component';
import { InfiniteScrollListComponent } from './components/infinite-scroll-list/infinite-scroll-list.component';
import { InputCurrencyComponent } from './components/input-currency/input-currency.component';
import { ForgetPasswordComponent } from './components/forget-password/forget-password.component';
import { RecoveryPasswordComponent } from './components/recovery-password/recovery-password.component';
import { NutritionalComponent } from './components/nutritional/nutritional.component';
import { NutritionalGroupComponent } from './components/nutritional-group/nutritional-group.component';
import { DashGraphicComponent } from './components/dash-graphic/dash-graphic.component';
import { PyramidDescComponent } from './components/pyramid-desc/pyramid-desc.component';
import { DuplicatePayComponent } from './components/duplicate-pay/duplicate-pay.component';
import { ConfirmDuplicateComponent } from './components/confirm-duplicate/confirm-duplicate.component';
import { BrowserModule, Title } from '@angular/platform-browser';
import { AppRoutingModule } from './app.routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Ng2CarouselamosModule } from './ng2-carouselamos/dist';
import { ChartModule } from 'angular2-chartjs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ImageCropperModule } from 'ng2-img-cropper';
import { AppService } from './app.service';
import { AuthGuard } from './guards/auth.guard';
import { AuthService } from './services/auth.service';
import { DependentService } from './services/dependent.service';
import { ExtractService } from './services/extract.service';
import { CreditCardService } from './services/credit-card.service';
import { ResponsibleService } from './services/responsible.service';
import { NotificationService } from './notification/swal/notification.service';
import { PageTitleService } from './services/pageTitle.service';
import { ProductService } from './services/product.service';
import { ConfigurationService } from './services/configuration.service';
import { CompanyService } from './services/company.service';
import { ImageService } from './services/image.service';
import { RechargeService } from './services/recharge.service';
import { MeepCardService } from './services/meepCard.service';
import { NutritionClassificationService } from './services/nutrition-classification.service';
import { EnergyGroupService } from './services/energy-group.service';
import { ForgetPasswordService } from './services/forgetPassword.service';
import { DuplicateMeepCardService } from './services/duplicate-meep-card.service';
import { PlanService } from './services/plan.service';
import { AppServiceInterceptor } from './interceptors/app.service.interceptor';
import { AppServiceAuthInterceptor } from './interceptors/app.service.auth.interceptor';
import { DefaultersComponent } from './components/defaulters/defaulters.component';
import { DebitDefaultersComponent } from './components/debit-defaulters/debit-defaulters.component';
import { ReembolsoComponent } from './components/reembolso/reembolso.component';
import { PlanComponent } from './components/plan/plan.component';
import { PlanDetailComponent } from './components/plan-detail/plan-detail.component';
import { CurrentSubscriptionComponent } from './components/current-subscription/current-subscription.component';
import { CurrentSubscriptionService } from './services/current-subscription.service';
import { BuscaCepService } from './services/busca-cep.service';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { WindowRefService } from './services/window.service';
import { PixService } from './services/paymentPix.service';
import { MinutesSecondsPipe } from './pipes/minutes-seconds.pipe';
import { DeleteAccountService } from './services/deleteAccount.service';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    RegisterComponent,
    AccountComponent,
    ExtractComponent,
    CreditCardComponent,
    CreditCardSingleComponent,
    DependentCardComponent,
    MinutesSecondsPipe,
    DependentSingleComponent,
    DailyLimitComponent,
    RestrictionComponent,
    RestrictionSingleComponent,
    ChangePasswordComponent,
    RegisterDependentComponent,
    RegisterDependentComponent,
    HeaderComponent,
    GeneralComponent,
    RechargeComponent,
    InputComponent,
    TextareaComponent,
    InputSelectComponent,
    InfiniteScrollListComponent,
    InputCurrencyComponent,
    ForgetPasswordComponent,
    RecoveryPasswordComponent,
    NutritionalComponent,
    NutritionalGroupComponent,
    DashGraphicComponent,
    PyramidDescComponent,
    DuplicatePayComponent,
    ConfirmDuplicateComponent,
    DefaultersComponent,
    DebitDefaultersComponent,
    ReembolsoComponent,
    PlanComponent,
    PlanDetailComponent,
    CurrentSubscriptionComponent,
    NotificationsComponent,
    TermsAndConditionsComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MatSidenavModule,
    HttpModule,
    HttpClientModule,
    Ng2CarouselamosModule,
    MatInputModule,
    MatListModule,
    ChartModule,
    FormsModule,
    MatTabsModule,
    MatSlideToggleModule,
    MatExpansionModule,
    ImageCropperModule,
    MatSelectModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatButtonModule,
    TextMaskModule

  ],
  providers: [
    AppService,
    Title,
    AuthGuard,
    AuthService,
    DependentService,
    ExtractService,
    CreditCardService,
    ResponsibleService,
    PixService,
    NotificationService,
    PageTitleService,
    ProductService,
    ConfigurationService,
    CompanyService,
    ImageService,
    RechargeService,
    MeepCardService,
    NutritionClassificationService,
    EnergyGroupService,
    ForgetPasswordService,
    DuplicateMeepCardService,
    ReembolsoService,
    PlanService,
    CurrentSubscriptionService,
    BuscaCepService,
    WindowRefService,
    DeleteAccountService,
    { provide: HTTP_INTERCEPTORS, useClass: AppServiceInterceptor, multi: true },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR '},
    { provide: HTTP_INTERCEPTORS, useClass: AppServiceAuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }




// WEBPACK FOOTER //
// /usr/src/app/src/app/app.module.ts